// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var CreditNoteEmailEditController = function ($scope, $rootScope, $routeParams, DocumentEmailTemplate, EmailTemplatePlaceholder, gettext, gettextCatalog) {
    EmailEditControllerBase('CreditNote', $scope, $rootScope, $routeParams, DocumentEmailTemplate, EmailTemplatePlaceholder, gettext, gettextCatalog);
};
CreditNoteEmailEditController.$inject = ['$scope', '$rootScope', '$routeParams', 'DocumentEmailTemplate', 'EmailTemplatePlaceholder', 'gettext', 'gettextCatalog'];
